import styled from "styled-components";
import { colors } from "@/theme";

export const TestPage = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const DebounceHeaderContainer = styled.div``;
export const DebounceContainer = styled.div``;
export const CodeLengthHeaderContainer = styled.div``;
export const CodeLengthContainer = styled.div``;
export const TestFnHeaderContainer = styled.div``;
export const TestFnContainer = styled.div`
  padding: 10px;
  border: 1px solid ${colors.black};
  border-radius: 12px;
`;
export const TextFieldHeaderContainer = styled.div``;
export const ScannerInputHeaderContainer = styled.div``;
export const TextFieldContainer = styled.div``;
export const ScannerInputContainer = styled.div``;
export const ClearLogContainer = styled.div``;
export const TextFieldLogContainer = styled.div``;
export const ScannerInputLogContainer = styled.div``;
